export const defaultCheckBoxData = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for checkbox.",
  },
];

export const defaultCheckBoxDataList = [
  {
    title: "Disabled Checks",
    span: [
      {
        id: "flexCheckDefault1",
        label: "Disabled checkbox",
        disabled: true,
      },
      {
        id: "flexCheckChecked2",
        label: "Disabled checked checkbox",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
  {
    title: "Right Checks",
    className: "form-check-reverse",
    span: [
      {
        id: "reverseCheck1",
        label: "Reverse checkbox",
      },
      {
        id: "reverseCheck2",
        label: "Disabled reverse checkbox",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
];

export const customCheckboxData = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for checkbox. And filled checkbox used ",
    code: ".checkbox-solid-*",
  },
  {
    text: " and bordered checkbox used ",
    code: ".checkbox-*",
  },
];

export const borderCheckboxData = [
  {
    color: "secondary",
    text: "Secondary - checkbox-secondary",
  },
  {
    color: "tertiary",
    text: "Tertiary - checkbox-tertiary",
  },
];

export const customCheckboxList = [
  {
    id: 1,
    icon: "fa fa-user",
    text: "User",
    defaultChecked: true,
  },
  {
    id: 2,
    icon: "fa fa-tag",
    text: "Tags",
  },
  {
    id: 3,
    icon: "fa fa-android",
    text: "Android",
  },
  {
    id: 4,
    icon: "fa fa-eye-slash",
    text: "Hidden",
  },
  {
    id: 5,
    icon: "fa fa-folder-open",
    text: "Folder",
  },
  {
    id: 6,
    icon: "fa fa-paper-plane",
    text: "Send",
  },
  {
    id: 7,
    icon: "fa fa-cloud-upload",
    text: "Upload",
  },
];

export const fillCheckboxList = [
  {
    id: 1,
    text: "Danger - checkbox-solid-danger",
    color: "danger",
  },
  {
    id: 2,
    text: "Info - checkbox-solid-info",
    color: "info",
  },
];

export const defaultRadioData = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for radios.",
  },
];

export const defaultRadioDataList = [
  {
    title: "Disabled Radios",
    span: [
      {
        id: "flexRadioDisabled",
        label: "Disabled radio",
        disabled: true,
      },
      {
        id: "flexRadioCheckedDisabled",
        label: "Disabled checked radio",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
  {
    title: "Right Radios",
    className: "form-check-reverse",
    span: [
      {
        id: "flexRadioDefault3",
        label: "Default radio",
      },
      {
        id: "flexRadioCheckedDisabled1",
        label: "Disabled checked radio",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
];

export const imageWithCheckboxData = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for image checkbox.",
  },
];

export const imageWithCheckboxDataList = [
  {
    id: "img-check-2",
    src: "2",
    label: "Checked Image",
    defaultChecked: true,
    alt: "tree",
  },
  {
    id: "img-check-3",
    src: "3",
    label: "Disable Image",
    disabled: true,
    alt: "flowers",
  },
  {
    id: "img-check-4",
    src: "4",
    label: "Disable Checked Image",
    alt: "rose-tea",
    disabled: true,
    defaultChecked: true,
  },
];

export const imageWithRadioData = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for image radio.",
  },
];

export const imageWithRadioDataList = [
  {
    id: "img-radio-2",
    src: "6",
    label: "Checked Image",
    defaultChecked: true,
    alt: "tree",
  },
  {
    id: "img-radio-3",
    src: "7",
    label: "Disable Image",
    disabled: true,
    alt: "flowers",
  },
  {
    id: "img-radio-4",
    src: "8",
    label: "Disable Checked Image",
    alt: "rose-tea",
    disabled: true,
    defaultChecked: true,
  },
];

export const customRadioData = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for radios.",
  },
];

export const borderedRadioData = [
  {
    id: "radio55",
    color: "danger",
    text: "Roxo Template ",
  },
  {
    id: "radio33",
    color: "warning",
    text: "Voxo Template",
  },
  {
    id: "radio66",
    color: "secondary",
    text: "Zeta Template",
  },
];

export const customRadioList = [
  {
    id: 1,
    icon: "fa-solid fa-eye-slash",
    text: "Hidden",
    defaultChecked: true,
  },
  {
    id: 2,
    icon: "fa-solid fa-folder-open",
    text: "Folder",
  },
  {
    id: 3,
    icon: "fa fa-paper-plane",
    text: "Send",
  },
  {
    id: 4,
    icon: "fa-solid fa-user",
    text: "User",
  },
  {
    id: 5,
    icon: "fa-solid fa-trash",
    text: "Trash",
  },
  {
    id: 6,
    icon: "fa-brands fa-github",
    text: "Github",
  },
  {
    id: 7,
    icon: "fa-solid fa-play",
    text: "Play",
  },
];

export const fillRadioList = [
  {
    id: 1,
    text: "Order history",
    color: "danger",
  },
  {
    id: 2,
    text: "Invoice",
    color: "warning",
  },
  {
    id: 3,
    text: "Wishlist",
    color: "secondary",
  },
];

export const defaultSwitchData = [
  {
    text: "Use the ",
    code: ".form-switch",
  },
  {
    text: " and ",
    code: ".form-check-label ",
  },
  {
    text: "for switches.",
  },
];

export const defaultSwitchDataList = [
  {
    title: "Disabled Switches",
    span: [
      {
        id: "flexSwitchCheckDisabled",
        label: "Disabled switch checkbox input",
        disabled: true,
      },
      {
        id: "flexSwitchCheckCheckedDisabled",
        label: "Disabled checked switch checkbox input",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
  {
    title: "Right Switches",
    className: "form-check-reverse",
    inputClass: "ms-2",
    span: [
      {
        id: "flexSwitchCheckReverse",
        label: "Reverse switch checkbox input",
      },
      {
        id: "flexSwitchCheckDisabled1",
        label: "Disabled switch checkbox input",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
];

export const inlineInputData = [
  {
    text: "Group checkboxes or radios on the same horizontal row by adding ",
    code: ".form-check-inline ",
  },
  {
    text: "to any",
    code: ".form-check.",
  },
];

export const inlineCheckboxData = [
  {
    id: "inlineCheckbox2",
    text: "II",
  },
  {
    id: "inlineCheckbox3",
    text: "III (disabled)",
    disabled: true,
  },
];

export const inlineRadioData = [
  {
    id: "inlineRadio2",
    text: "2",
  },
  {
    id: "inlineRadio3",
    text: "3 (disabled)",
    disabled: true,
  },
];

export const inlineSwitchData = [
  {
    id: "flexSwitchCheckDefault3",
  },
  {
    id: "flexSwitchCheckDisabled3",
    disabled: true,
  },
];

export const animatedButtonData = [
  {
    text: "Use the ",
    code: ".radio_animated ",
  },
  {
    text: "through animated checkbox and radios.",
  },
];

export const animatedPaymentData = [
  {
    id: "edo-ani1",
    text: "MasterCard",
    color:"secondary"
  },
  {
    id: "edo-ani2",
    text: "Paypal",
    defaultChecked: true,
    color:"tertiary"
  },
  {
    id: "edo-ani13",
    text: "G-pay",
    color:"success"
  },
  {
    id: "edo-ani6",
    text: " Bitpay",
    color:"info"
  },
];

export const animatedSocialData = [
  {
    id: "chk-ani1",
    text: "Facebook",
    color:"secondary"
  },
  {
    id: "chk-ani2",
    text: "Whatsapp",
    defaultChecked: true,
    color:"tertiary"
  },
  {
    id: "chk-ani3",
    text: "Twitter",
    color:"danger"
  },
  {
    id: "chk-ani4",
    text: "Linkedin",
    color:"info"
  },
];

export const basicRadioCheckboxData = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "through display inline.",
  },
];

export const basicRadioCheckboxDataList = [
  {
    id: "inline-2",
    text: "Gallery",
    defaultChecked: true,
  },
  {
    id: "inline-3",
    text: "Faq",
  },
  {
    id: "inline-4",
    text: "Email",
  },
  {
    id: "inline-5",
    text: "Icons",
  },
];

export const basicRadioDataList = [
  {
    id: "radioinline2",
    text: "Tasks",
  },
  {
    id: "radioinline3",
    text: " To-do",
  },
  {
    id: "radioinline4",
    text: "Forms",
  },
  {
    id: "radioinline5",
    text: "Login",
  },
];

export const radioToggleData = [
  {
    text: "The choice between these two approaches will depend on the type of toggle you are creating, and whether or not the toggle will make sense to users when announced as a checkbox or as an actual button. ",
    code: "[any one selected].",
  },
];

export const radioToggleDataList = [
  {
    id: "option2",
    text: "Radio",
  },
  {
    id: "option3",
    text: "Disabled",
    disabled: true,
  },
  {
    id: "option4",
    text: "Radio",
  },
];

export const outlineCheckboxData = [
  {
    text: "The choice between these two approaches will depend on the type of toggle you are creating, and whether or not the toggle will make sense to users when announced as a checkbox or as an actual button. ",
    code: "[multiple selected].",
  },
];
